import {
  EMAIL_SIGN_UP_DEFAULT_FORM_VALUES,
  SIGNUP_FORM_ROUTES,
  SSO_SIGN_UP_CREDENTIALS_SESSION_STORAGE_KEY,
} from '../constants';
import { type SignupType } from '../types';

import { useRedirectQueryParam } from '@/modules/auth/useRedirectQueryParam';
import { type SSOSignupCredentials } from '@/modules/login/types';
import { useExtendedRouter } from '@/modules/routing/useExtendedRouter';
import { setSessionStorageItem } from '@/modules/storage';

type Props = {
  ssoType: SignupType;
};

export function useSSOSignup({ ssoType }: Props) {
  const redirectQueryParam = useRedirectQueryParam();
  const router = useExtendedRouter();
  const signupFormPath =
    SIGNUP_FORM_ROUTES[ssoType.toLowerCase() as keyof typeof SIGNUP_FORM_ROUTES]
      .path;

  async function signupWithSSO({
    credentials,
    email,
    name,
  }: {
    email: string;
    credentials: SSOSignupCredentials;
    name?: {
      firstName: string;
      lastName: string;
    };
  }) {
    setSessionStorageItem(
      SSO_SIGN_UP_CREDENTIALS_SESSION_STORAGE_KEY,
      JSON.stringify({
        ...EMAIL_SIGN_UP_DEFAULT_FORM_VALUES,
        email,
        ...(name?.firstName && { firstName: name.firstName }),
        ...(name?.lastName && { lastName: name.lastName }),
        ...credentials,
      })
    );

    return router.push(`${signupFormPath}${redirectQueryParam}`);
  }

  return {
    signupWithSSO,
  };
}
